/**
 * The print page and print-template designer announcement (PrintPageIntroGate, in the panel layout)
 * opens on this event, whether or not it was closed or dismissed before; its item in «امکانات تازه»
 * sends it.
 */
export const PRINT_PAGE_INTRO_EVENT = 'mp:whats-new'

export const openPrintPageIntro = (): void => {
  window.dispatchEvent(new Event(PRINT_PAGE_INTRO_EVENT))
}
